/* unplugin-vue-components disabled */import script from "./detail-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./detail-modal.vue?vue&type=script&setup=true&lang=js"

import "./detail-modal.vue?vue&type=style&index=0&id=bbc85178&lang=scss"

const __exports__ = script;

export default __exports__